export const comiteEtica = [
    {
        'anio' : '2026',
        'archivos' : [
            {
                'programa' : 'Programa Anual de Trabajo',
                'urlPrograma' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2026/ProgramaAnualTrabajoCEPCI2026.pdf',
                // 'informe' : 'Informe Anual de Actividades',
                // 'urlInforme' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2026/InformeAnualActividadesCEPCI2026.pdf',
            }
        ]
    },
    {
        'anio' : '2025',
        'archivos' : [
            {
                'programa' : 'Programa Anual de Actividades',
                'urlPrograma' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2025/ProgramaAnualTrabajoCEPCI2025.pdf',
                'informe' : 'Informe Anual de Actividades',
                'urlInforme' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2025/InformeAnualActividadesCEPCI2025.pdf',
            }
        ]
    },
    {
        'anio' : '2024',
        'archivos' : [
            {
                'programa' : 'Programa Anual de Actividades',
                'urlPrograma' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2024/ProgramaAnualTrabajoCEPCI2024.pdf',
                'informe' : 'Informe Anual de Actividades',
                'urlInforme' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2024/InformeAnualActividadesCEPCI2024.pdf',
            }
        ]
    },
    {
        'anio' : '2023',
        'archivos' : [
            {
                'programa' : 'Programa Anual de Trabajo',
                'urlPrograma' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2023/ProgramaAnualTrabajoCEPCI2023.pdf',
                'informe' : 'Informe Anual de Actividades',
                'urlInforme' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2023/InformeAnualActividadesCEPCI2023.pdf',
            }
        ]
    },
    {
        'anio' : '2022',
        'archivos' : [
            {
                'programa' : 'Programa Anual de Trabajo',
                'urlPrograma' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2022/ProgramaAnualTrabajoCEPCI2022.pdf',
                'informe' : 'Informe Anual de Actividades',
                'urlInforme' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2022/InformeAnualActividadesCEPCI2022.pdf',
            }
        ]
    },
    {
        'anio' : '2021',
        'archivos' : [
            {
                'programa' : 'Programa Anual de Trabajo',
                'urlPrograma' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2021/ProgramaAnualTrabajoCEPCI2021.pdf',
                'informe' : 'Informe Anual de Actividades',
                'urlInforme' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/CEPCI/2021/InformeAnualActividadesCEPCI2021.pdf',
            }
        ]
    },
]